import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../Auth';
import PageTable from '../../../Shared/PageTable/PageTable';

import styles from './DisabledBreedings.module.scss';

function DisabledBreedings() {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();

    const columns = [
        {
            label: t("requestbreeding.fields.CREATEDTIME"),
            field: "CREATEDTIME",
            override: (data: any) => new Date(data.CREATEDTIME).toLocaleString("no-NO"),
        },
        {
            label: t("requestbreeding.fields.DAM_ANIMAL_NAME"),
            field: "DAM_ANIMAL_NAME",
        },
        {
            label: t("requestbreeding.fields.SIRE_ANIMAL_NAME"),
            field: "SIRE_ANIMAL_NAME",
        },
        {
            label: t("requestbreeding.fields.DAM_OWNER_NAME"),
            field: "DAM_OWNER_NAME",
            override: (data: any) => data.DAM_OWNER_NAME === ", " ? "" : data.DAM_OWNER_NAME,
        },
    ];

    return (
        <div className={styles.disabledbreedings}>
            <PageTable
                dataUrl="/api/breedings/getAllPaged"
                onLineClick={(dataLine: any) => {
                    navigate("/openbreedings/" + dataLine.ID);
                }}
                options={{
                    showFields: columns,
                }}
                permaFilters={[
                    {
                        field: "BREED_ID",
                        exact: false,
                        type: "and",
                        values: [auth.selectedBreed?.toString() || ""]
                    },
                    {
                        field: "STATUS",
                        exact: true,
                        type: "and",
                        values: ["disabled"]
                    },
                ]}
                selectedTraits={[
                    { field: "CREATEDTIME" },
                    { field: "DAM_ANIMAL_NAME" },
                    { field: "SIRE_ANIMAL_NAME" },
                    { field: "DAM_OWNER_NAME" },
                ]}
                clickable
                defaultSortDirection="DESC"
                defaultSortField="CREATEDTIME"
                hidePagination={false}
                hidePagesize={false}
                hideFilter={false}
            />
        </div>
    );
}

export default DisabledBreedings;
